import {
  Home as HomeIcon,
  List as ListIcon,
  LocationCity as LocationCityIcon,
  AssessmentTwoTone,
  HolidayVillage,
  ChecklistRtl,
  StackedLineChart
} from '@mui/icons-material';
import { MarketCode, RoleEmployee, RoleUser } from '@homesusa/core';
import { AppType, SidebarItemType, QuicklisterEndpoint as RouterPath } from '../enums';
import { SidebarItem } from '../interfaces';
import { getSidebarEndpoint } from './get-sidebar-endpoint';

const getEndpoint = (endpoint: RouterPath): string =>
  getSidebarEndpoint(AppType.Quicklister, endpoint);

export const getQuicklisterReleaseNotes = (
  getQLEndpoint: (endpoint: RouterPath) => string = getEndpoint
): Record<string, SidebarItem> => ({
  [SidebarItemType.ReleaseNotes]: {
    title: 'Release Notes',
    icon: ChecklistRtl,
    items: [
      {
        title: 'Release Notes',
        endpoint: getQLEndpoint(RouterPath.ReleaseNotes)
      }
    ]
  }
});

export const getQuicklisterSidebarItems = (
  getQLEndpoint: (endpoint: RouterPath) => string = getEndpoint
): Record<string, SidebarItem> => {
  const excludeUserRoles = [RoleUser.Photographer];
  return {
    [SidebarItemType.Dashboard]: {
      title: 'Home',
      icon: HomeIcon,
      endpoint: '/'
    },
    [SidebarItemType.Listings]: {
      title: 'Listings',
      icon: HolidayVillage,
      excludeUserRoles,
      items: [
        { title: 'Residential', endpoint: getQLEndpoint(RouterPath.SaleListings) },
        {
          title: 'Lot',
          endpoint: getQLEndpoint(RouterPath.LotListings),
          filterByMarket: [MarketCode.Austin, MarketCode.Houston]
        }
      ]
    },
    [SidebarItemType.Profiles]: {
      title: 'Profiles',
      icon: LocationCityIcon,
      excludeUserRoles,
      items: [
        { title: 'Community', endpoint: getQLEndpoint(RouterPath.Communities) },
        { title: 'Plan', endpoint: getQLEndpoint(RouterPath.Plans) }
      ]
    },
    [SidebarItemType.ListingRequests]: {
      title: 'Listing Requests',
      icon: ListIcon,
      excludeUserRoles,
      allowedEmployeeRoles: [
        RoleEmployee.CompanyAdmin,
        RoleEmployee.CompanyAdminReadonly,
        RoleEmployee.SalesEmployee
      ],
      items: [
        {
          title: 'Residential',
          endpoint: getQLEndpoint(RouterPath.SaleListingRequests)
        },
        {
          title: 'Lot',
          endpoint: getQLEndpoint(RouterPath.LotListingRequests),
          filterByMarket: [MarketCode.Austin, MarketCode.Houston]
        }
      ]
    },
    [SidebarItemType.Reports]: {
      title: 'Reports',
      icon: AssessmentTwoTone,
      excludeUserRoles,
      items: [
        { title: 'Realtor Intel', endpoint: getQLEndpoint(RouterPath.Reports) },
        {
          title: 'Billing Report',
          allowedUserRoles: [RoleUser.MLSAdministrator],
          endpoint: getQLEndpoint(RouterPath.BillingReport)
        },
        {
          title: 'Photography Billing',
          allowedUserRoles: [RoleUser.MLSAdministrator],
          endpoint: getSidebarEndpoint(AppType.PhotoService, 'photographer-billing-reports')
        },
        {
          title: 'Photographers Payroll',
          allowedUserRoles: [RoleUser.MLSAdministrator],
          endpoint: getSidebarEndpoint(AppType.PhotoService, 'photographer-payroll-reports')
        }
      ]
    },
    [SidebarItemType.HomesIQ]: {
      title: 'Homes IQ',
      icon: StackedLineChart,
      items: [
        { title: 'Texas Index', endpoint: getQLEndpoint(RouterPath.TexasIndex) },
        {
          title: 'Weekly Charts',
          endpoint: getQLEndpoint(RouterPath.WeeklyCharts)
        }
      ]
    }
  };
};
